import React from "react";

export const SettingsHelp = () => {
	return <p>Under construnction...</p>;
};
